import React from 'react';
import styled from '@emotion/styled';
import { Container, Flex, Text } from 'basis';
import { formatNumber } from 'utils/formatNumber';
import { getRatesAndFees } from 'featureToggles';
import { calculateMonthlyRepayment } from 'utils/calculateMonthlyRepayment';
import { isAU, isDJ } from 'utils';

export const ApprovedCreditLimit = ({ creditLimitApproved }) => {
  const bgColor = isAU() && !isDJ() ? 'specialBackground' : 'grey.t07';
  const monthlyRepaymentRate = getRatesAndFees()?.minimumRepaymentRate;
  return (
    <>
      <RoundCorner>
        <Container name="creditLimitAmount" bg={bgColor} width="100%" padding="6" margin="3 0 0 0">
          <Flex height="100%" placeItems="top center">
            <Text textStyle="heading3" testId="approved-credit-limit">
              <span data-hj-suppress>${formatNumber(creditLimitApproved)}</span>
            </Text>
          </Flex>
        </Container>
      </RoundCorner>
      <Container margin="2 0 8 0">
        <Text testId="monthly-repayment">
          Your minimum monthly repayment will be{' '}
          <b data-hj-suppress>${calculateMonthlyRepayment(creditLimitApproved, monthlyRepaymentRate)} at this limit</b>
        </Text>
      </Container>
    </>
  );
};

const RoundCorner = styled.div`
  & > div {
    border-radius: 12px;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  }
`;
